class LL_Dialog extends HTMLElement {
  constructor() {
    super();
    this.dialogElement = this.querySelector('.js_dialog');
    this.toggleButtons = this.querySelectorAll('.js_dialogToggle');

    this.dialogElement.addEventListener('click', event => {
      if (event.target === this.dialogElement) {
        this.toggleDialog();
      }
    });

    // this.dialogElement.addEventListener('click', this.closeDialog.bind(this));

    this.toggleButtons.forEach(button => {
      button.addEventListener('click', this.toggleDialog.bind(this));
    });
  }

  /**
   * Toggle dialog visibility based on its current state
   */
  toggleDialog() {
    if (this.isDialogOpen()) {
      this.closeDialog();
    } else {
      this.openDialog();
    }
  }

  /**
   * Check if the dialog is currently open
   * @returns {Boolean} True if the dialog is open
   */
  isDialogOpen() {
    return this.dialogElement.hasAttribute('open');
  }

  /**
   * Open the dialog and add necessary event listeners
   */
  openDialog() {
    if (typeof this.dialogElement.showModal === "function") {
      this.dialogElement.showModal();
    } else {
      console.error('The <dialog> API is not supported by this browser');
    }
  }

    /**
   * Close the dialog and remove event listeners
   */
  closeDialog() {
    this.dialogElement.close();
  }
}

customElements.define('ll-dialog', LL_Dialog);